import React from 'react';
import { Result, Button } from 'antd';
import { ExpiredIcon } from '../../common/icons/ExpiredIcon';

export interface InvalidTokenResultProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
}

export const InvalidTokenResult: React.FC<InvalidTokenResultProps> = ({
  title = 'Invalid or Expired Link',
  subtitle = 'The password reset link is invalid or has expired. For security reasons, reset links are only valid for a limited time.To reset your password, please request a new link by clicking the button below.',
  buttonText = 'Request Reset Link',
  onButtonClick,
  showButton = true,
}) => {
  return (
    <Result
      status="error"
      icon={<ExpiredIcon />}
      title={title}
      subTitle={subtitle}
      extra={
        showButton && onButtonClick ? (
          <Button
            type="primary"
            onClick={onButtonClick}
            style={{
              backgroundColor: '#05796B',
              borderColor: '#05796B',
              height: '40px',
              fontSize: '16px',
              fontWeight: '600',
            }}
          >
            {buttonText}
          </Button>
        ) : null
      }
    />
  );
};
